import React from "react";
import { CreateContainer } from "./ContainerCreate";
import { getQuoteComments } from "../api/getQuotes";
import LoadMoreContainer from "./LoadMoreContainer";
import LoadMore from "../Components/Global/LoadMore";

// import Comment from "../Components/Global/Comment";
import CommentForm from "~/Components/Elements/Forms/Comments/CommentForm";
// import MockComments from "../api/mocks/comments.json";

class CommentsContainer extends LoadMoreContainer {
  constructor(props) {
    super(props);
    this.state = { page: 1, hasMore: false, type: "comment", items: [] };
  }
  fetch = () => {
    const {
      quote: { id: quoteId },
    } = this.props;
    return this.props.request(quoteId).then(({ data }) => {
      this.fetching = false;
      const hasMore = false; //data && data.length === 10;
      const items = this.state.items.slice(0);
      const { comments } = data || [];
      // MOCK COMMENTS
      // const comments = MockComments.comments;
      comments.map((t) => items.push(t));
      this.setState({ items, page: (this.state.page += 1), hasMore });
    });
  };
  setReplies = (comments) => {
    this.setState({ ...this.state, items: comments });
  };
  render = () => {
    const { items, hasMore } = this.state;
    const { loading, quote } = this.props;
    return (
      <React.Fragment>
        {/* {!loading && items.length === 0 && (
          <div className="">
            <div>No comments yet. But you can add one below.</div>
          </div>
        )} */}
        {/* {!loading && items.length > 0 && quote && (
          <div className="">
            <h3>Comments</h3>
          </div>
        )} */}

        {items && items.length > 0 && (
          <ul className="list-unstyled comment-list">
            {items.map((comment) => (
              <li key={comment.id}>
                <p>
                  <strong>{comment.user}</strong>
                  {comment.allow_html ? (
                    <span className="comment-body" dangerouslySetInnerHTML={{ __html: comment.comments }} />
                  ) : (
                    <span className="comment-body">{comment.comments}</span>
                  )}
                  <span className="date">{comment.date}</span>
                </p>
              </li>
            ))}
          </ul>
        )}

        <LoadMore loading={loading} hasMore={hasMore} items={items} pagination={this.pagination} />

        <CommentForm quote={quote} onReply={(replies) => (replies = this.setReplies(replies))} />
      </React.Fragment>
    );
  };
}

export default CreateContainer(getQuoteComments, CommentsContainer);
